import RangeSlider from "../RangeSlider/RangeSlider";

// eslint-disable-next-line no-unused-vars
const rangeSlider = new RangeSlider({
  selector: ".js-grid-range-slider",
  onChange(values) {
    window.gridRangeSliderChange(values);
  },
});
